<template>
  <div class="cidr">
    <div class="fl cidrSelectBox">
      <!--cidr下拉-->
      <el-select v-model="cidr1Val"
                 @change="cidr5Val = cidr5Option[0];changeCidr1()"
                 style="width:70px;" popper-class="cidr-select" :disabled="hasSubnet ||
                 (createSubnet && selectedVpc)">
        <el-option v-for="item in cidr1Option" :label="item" :value="item" :key="item"></el-option>
      </el-select>
    </div>
    <div class="stext">.</div>
    <div class="sdiv" v-if="hasSubnet || createSubnet">
      <input type="text" class="inputMode w40 tcenter" v-model="cidr2Val" :disabled="hasSubnet
      || (createSubnet && selectedVpc)">
    </div>
    <div class="sdiv" v-else>
      <input type="number" maxlength="3"
             oninput="javascript: if (this.value.length > this.maxLength)
               this.value = this.value.slice(0, this.maxLength);"
             v-bind:class="{'cidr-not-in-range': cidr2ValueNotInRange}" @focus="tip2Focus = true;"
             @blur="tip2Focus = false; blurCidr2Val(cidr2Val,selectCidrMapOption.availableData2);"
             class="inputMode w40 tcenter" v-model="cidr2Val"
             :disabled="selectCidrMapOption.secondDisable  || createSubnet">
      <p class="right-tips" v-bind:class="{'not-in-range-tips':cidr2ValueNotInRange}"
         style="display: block;"
         v-show="tip2Focus && selectCidrMapOption.tip2">{{selectCidrMapOption.tip2}}</p>
      <div v-if="cidr2ValueNotInRange && tip2Focus" class="down-arrow"></div>
    </div>
    <div class="stext">.</div>
    <div class="sdiv" v-if="hasSubnet">
      <input type="text" class="inputMode w40 tcenter" v-model="cidr3Val" :disabled="true">
    </div>
    <div class="sdiv" v-else>
      <input maxlength="3"
             oninput="javascript:
             if (this.value.length > this.maxLength)
               this.value = this.value.slice(0, this.maxLength);"
             v-bind:class="{'cidr-not-in-range': cidr3ValueNotInRange}" type="number"
             @focus="tip3Focus = true;"
             @blur="tip3Focus = false;blurCidr3Val(cidr3Val,selectCidrMapOption.availableData3);"
             class="inputMode w40 tcenter" v-model="cidr3Val"
             :disabled="selectCidrMapOption.thirdDisable">
      <p class="right-tips" v-bind:class="{'not-in-range-tips':cidr3ValueNotInRange}"
         style="display: block;"
         v-show="tip3Focus && selectCidrMapOption.tip3">{{selectCidrMapOption.tip3}}</p>
      <div v-if="cidr3ValueNotInRange && tip3Focus" class="down-arrow"></div>
    </div>
    <div class="stext">.</div>
    <div class="sdiv" v-if="hasSubnet">
      <input type="text" class="inputMode w40 tcenter" v-model="cidr4Val" :disabled="true"></div>
    <div class="sdiv" v-else>
      <input maxlength="3"
             oninput="javascript: if (this.value.length > this.maxLength)
               this.value = this.value.slice(0, this.maxLength);"
             v-bind:class="{'cidr-not-in-range': cidr4ValueNotInRange}" type="number"
             @focus="tip4Focus = true;"
             @blur="tip4Focus = false;blurCidr4Val(cidr4Val,selectCidrMapOption.availableData4);"
             class="inputMode w40 tcenter" v-model="cidr4Val"
             :disabled="selectCidrMapOption.fourthDisable">
      <p class="right-tips" v-bind:class="{'not-in-range-tips':cidr4ValueNotInRange}"
         style="display: block;"
         v-show="tip4Focus && selectCidrMapOption.tip4">{{selectCidrMapOption.tip4}}</p>
      <div v-if="cidr4ValueNotInRange && tip4Focus" class="down-arrow"></div>
    </div>
    <div class="stext">/</div>
    <div class="select-box time fl cidrSelectBox">
      <!--cidr下拉框-->
      <el-select popper-class="cidr-select" id="cidr5-select" v-model="cidr5Val" @change="changeCidr5"
                 style="width:70px;" :disabled="hasSubnet">
        <el-option v-for="item in cidr5Option" :label="item" :value="item" :key="item"></el-option>
      </el-select>
      <p class="right-tips"
         v-bind:class="{'not-in-range-tips subnet-failed':subnetCheckFailed}" style="display:
         block;"
         v-show="subnetCheckFailed">{{subnetCheckErrMsg}}</p>
      <div v-if="subnetCheckFailed" class="down-arrow-select"></div>
    </div>
  </div>
</template>

<script>
import { cidrList } from '@/common/ConstParam';

export default {
  name: 'Cidr',
  data() {
    // cidr地址第一位可选值
    const cidr1Option = [10, 172, 192];
    // 子网掩码可选值
    const cidr5Option = [16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28];
    return {
      cidr1Val: 10,
      cidr2Val: 0,
      cidr3Val: 0,
      cidr4Val: 0,
      cidr5Val: 16,
      selectCidrMapOption: cidrList.cidrOption['10']['16'],
      cidr1Option,
      cidr5Option,
      cidr2ValueNotInRange: false,
      cidr3ValueNotInRange: false,
      cidr4ValueNotInRange: false,
      tip2Focus: false,
      tip3Focus: false,
      tip4Focus: false,
      init: true
    };
  },
  mounted() {},
  props: {
    cidrArray: {
      type: Array,
      default:
          () => [10, 0, 0, 0, 16]
    },
    hasSubnet: {
      type: Boolean,
      default:
          false
    },
    // 是否是创建子网
    createSubnet: {
      type: Boolean,
      default: false
    },
    // 创建子网是否失败
    subnetCheckFailed: {
      type: Boolean,
      default: false
    },
    // 创建子网失败话术
    subnetCheckErrMsg: {
      type: String,
      default: ''
    },
    // 是否选择vpc
    selectedVpc: {
      style: Boolean,
      default:false
    }
  },
  methods: {
    // 改变cidr第一块
    changeCidr1() {
      if (!this.hasSubnet) {
        this.selectCidrMapOption = cidrList.cidrOption[this.cidr1Val][this.cidr5Val];
        if(!this.createSubnet || !this.selectedVpc){
          this.cidr2Val = this.selectCidrMapOption.secondVal;
        }
        this.cidr3Val = this.selectCidrMapOption.thirdVal;
        this.cidr4Val = this.selectCidrMapOption.fourthVal;
        this.cidr2ValueNotInRange = false;
        this.cidr3ValueNotInRange = false;
        this.cidr4ValueNotInRange = false;
      }
    },
    // 改变cidr最后一块
    changeCidr5() {
      if (!this.hasSubNet) {
        const setCIdr4 = [17, 18, 19, 20, 21, 22, 23, 24];
        this.selectCidrMapOption = cidrList.cidrOption[this.cidr1Val][this.cidr5Val];
        this.cidr2ValueNotInRange = false;
        this.cidr3ValueNotInRange = false;
        this.cidr4ValueNotInRange = false;
        this.tip2Focus = false;
        this.tip3Focus = false;
        this.tip4Focus = false;
        if (this.cidr5Val === 16) {
          this.cidr3Val = this.selectCidrMapOption.thirdVal;
          this.cidr4Val = this.selectCidrMapOption.fourthVal;
          this.focusCidrVal(this.cidr2Val, 'cidr2', this.selectCidrMapOption.availableData2);
        } else if (setCIdr4.indexOf(this.cidr5Val) !== -1) {
          this.cidr4Val = this.selectCidrMapOption.fourthVal;
          this.focusCidrVal(this.cidr2Val, 'cidr2', this.selectCidrMapOption.availableData2);
          this.focusCidrVal(this.cidr3Val, 'cidr3', this.selectCidrMapOption.availableData3);
        } else {
          this.focusCidrVal(this.cidr2Val, 'cidr2', this.selectCidrMapOption.availableData2);
          this.focusCidrVal(this.cidr3Val, 'cidr3', this.selectCidrMapOption.availableData3);
          this.focusCidrVal(this.cidr4Val, 'cidr4', this.selectCidrMapOption.availableData4);
        }
      }
    },
    focusCidrVal(val, cidrType, availableDataList) {
      let changeVal = val;
      if (isNaN(val)) {
        changeVal = availableDataList[0];
      } else {
        changeVal = parseInt(val, 10);
      }
      switch (cidrType) {
        case 'cidr2': {
          if (availableDataList.indexOf(changeVal) === -1) {
            this.cidr2ValueNotInRange = true;
          }
          break;
        }
        case 'cidr3': {
          if (availableDataList.indexOf(changeVal) === -1) {
            this.cidr3ValueNotInRange = true;
          }
          break;
        }
        case 'cidr4': {
          if (availableDataList.indexOf(changeVal) === -1) {
            this.cidr4ValueNotInRange = true;
          }
          break;
        }
        default: {
          break;
        }
      }
    },
    blurCidr2Val(val, availableDataList) {
      let changeVal = val;
      if (val === '') {
        changeVal = availableDataList[0];
      } else {
        changeVal = parseInt(val, 10);
      }
      this.cidr2Val = changeVal;
      if (availableDataList.indexOf(changeVal) !== -1) {
        this.cidr2ValueNotInRange = false;
      } else {
        this.cidr2ValueNotInRange = true;
      }
    },
    blurCidr3Val(val, availableDataList) {
      let changeVal = val;
      if (val === '') {
        changeVal = availableDataList[0];
      } else {
        changeVal = parseInt(val, 10);
      }
      this.cidr3Val = changeVal;
      if (availableDataList.indexOf(changeVal) !== -1) {
        this.cidr3ValueNotInRange = false;
      } else {
        this.cidr3ValueNotInRange = true;
      }
    },
    blurCidr4Val(val, availableDataList) {
      let changeVal = val;
      if (val === '') {
        changeVal = availableDataList[0];
      } else {
        changeVal = parseInt(val, 10);
      }
      this.cidr4Val = changeVal;
      if (availableDataList.indexOf(changeVal) !== -1) {
        this.cidr4ValueNotInRange = false;
      } else {
        this.cidr4ValueNotInRange = true;
      }
    },
    /**
       **@disc:同步父组件传递进来的cidr值
       **@params:none
       */
    syncCidrVal() {
      [this.cidr1Val, this.cidr2Val, this.cidr3Val, this.cidr4Val, this.cidr5Val] = this.cidrArray;
      this.changeCidr5();
    //   this.filterValidateCidr5Val();
    },
    /**
       **@disc:将子组件中修改的值发射给父组件
       **@params:none
       */
    emitCidrVal() {
      this.$emit('cidrValsInArray', [this.cidr1Val, this.cidr2Val, this.cidr3Val, this.cidr4Val,
        this.cidr5Val]);
    },
    /**
       **@disc:如果是创建子网，cidr5Val逻辑处理
       **@params:
       */
    filterValidateCidr5Val() {
      if (this.createSubnet) {
        this.cidr5Option = this.cidr5Option.filter(item => item >= this.cidr5Val);
      }
    }
  },
  watch: {
    // 创建针对props属性的watch来同步组件外对props的修改
    cidr1Val() {
      this.emitCidrVal();
    },
    cidr2Val() {
      console.log(this.cidr2Val)
      this.emitCidrVal();
    },
    cidr3Val() {
      this.emitCidrVal();
    },
    cidr4Val() {
      this.emitCidrVal();
    },
    cidr5Val() {
      if (this.init && this.selectedVpc) {
        this.filterValidateCidr5Val()
      }
      this.emitCidrVal();
      if(this.selectedVpc){
        this.init = false;
      }
    },
    cidrArray(newVal) {
        console.log(newVal, 444);
      /**
       * 当数组newVal变化为，['10', '0', 0, 0, '16']，初始化状态，判断第五位是否为16
       * selectCidrMapOption: cidrList.cidrOption['10']['16']
       * cidr1Option: [10, 172, 192]
       * cidr5Option: [16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28]
       */
      // 检查是否为初始化状态 ['10', '0', 0, 0, '16']
      if (JSON.stringify(newVal) === JSON.stringify(['10', '0', 0, 0, '16']) || newVal[4] === '16') {
        // 设置初始化状态
        this.selectCidrMapOption = cidrList.cidrOption['10']['16'];
        this.cidr1Option = [10, 172, 192];
        this.cidr5Option = [16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28];
      }
      this.syncCidrVal();
    }
  }
};
</script>

<style lang="scss">
  @import 'style';
</style>



// WEBPACK FOOTER //
// src/components/common/cidr/Cidr.vue